export const IS_WEB_P_SUPPORTED_START = "IS_WEB_P_SUPPORTED_START";
export const IS_WEB_P_SUPPORTED_SUCCESS = "IS_WEB_P_SUPPORTED_SUCCESS";
export const IS_WEB_P_SUPPORTED_FAILURE = "IS_WEB_P_SUPPORTED_FAILURE";
